const America = [
  {
    id: 21,
    continent: 'america',
    img: require( '../Images/America/new-york-robert-bye.jpg' ),
    title: 'New York',
    quote: 'More than anything else New York is a city of superlatives, a place where the best, the brightest, the biggest is the norm.',
    autor:  'Marilyn J. Appleberg',
    adultCount: 0,
    childrenCount: 0,
    totalTravelers: 0,
    total: 0,
    dailyTrip: true,
    dailyTripDate1: "28/03/2036",
    dailyTripDate2: "28/05/2036",
    dailyTripDate3: "28/11/2036",
    dailyPriceAdult: 299.99,
    dailyPriceChildren: 199.99,
    weekTrip: true,
    weekTripDate1: "18/01/2036 - 25/01/2036",
    weekTripDate2: "18/05/2036 - 25/05/2036",
    weekTripDate3: "18/11/2036 - 25/11/2036",
    weekPriceAdult: 399.99,
    weekPriceChildren: 299.99,
    monthTrip: false,
    monthTripDate1: "30/03/2036 - 30/04/2036",
    monthTripDate2: "30/06/2036 - 30/07/2036",
    monthTripDate3: "30/09/2036 - 30/10/2036",
    monthPriceAdult: 1099.99,
    monthPriceChildren: 799.99,
    choosenTrip: "",
    tripPriceAdult: "",
    tripPriceChildren: "",
    dateOption: "",
    choosenDate: "",
    link: "/america/new-york",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer hendrerit mattis rhoncus. In eu nunc malesuada, consequat sem a, semper diam. Vestibulum mollis sagittis diam. Aliquam hendrerit tellus sit amet ante rhoncus, blandit mollis lectus sagittis. Aliquam dignissim blandit nisi id laoreet. Phasellus tempus elementum lacinia. Quisque ullamcorper ultricies tortor sit amet scelerisque. Etiam eu magna elementum, euismod tortor nec, efficitur turpis. Mauris consectetur magna suscipit, mattis leo et, bibendum lorem. Integer pretium eu enim nec hendrerit.",
    description2:
      "Nulla sit amet ultrices nunc. Proin sed accumsan risus. Ut tristique lorem ut nunc tempus fermentum. Fusce eu ex sed ligula placerat dapibus. Mauris quis felis porttitor dolor rutrum vehicula ac eu est. Aenean placerat erat vel elementum condimentum. Aliquam pulvinar nisl tellus. Donec ac scelerisque mauris.",
    description3:
      "Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; Duis volutpat tincidunt nisi, ut porttitor orci ultricies vel. Sed venenatis suscipit vulputate. Pellentesque lacus leo, bibendum eu nisi varius, varius porttitor erat. Praesent scelerisque tempor efficitur. Proin ut condimentum nisi, ac facilisis dolor. Phasellus at felis tempus, volutpat lacus a, aliquet risus. Curabitur eu feugiat lectus. Aliquam cursus dolor mollis nisi commodo, id malesuada mi condimentum. Vivamus id metus vitae ante consequat venenatis.",
    inCart: false,
    standardPickUp: 'Unavaiable',
    pickUp: 129,
    choosenPickUp: 0,
    hotelStandard: 0,
    hotelOption1: 100,
    hotelOption2: 149,
    hotelOption3: 169,
    choosenHotel: 0,
    tripStandard: 0,
    tripOption1: 79,
    tripDescription1: 'Donec sit amet dui tempus tellus congue scelerisque et id est. In consequat finibus consectetur.',
    choosenTripOption: 0,
    totalWithOptions: 0
  },
  {
    id: 22,
    continent: 'america',
    img: require( '../Images/America/Miami-ryan-parker.jpg' ),
    title: 'Miami',
    quote: 'One of my favorite vacation places is Miami, because of the people, the water and the beach - of course - and the architecture on Miami Beach is so wonderful.',
    autor:  'Oksana Baiul',
    adultCount: 0,
    childrenCount: 0,
    totalTravelers: 0,
    total: 0,
    dailyTrip: true,
    dailyTripDate1: "13/02/2036",
    dailyTripDate2: "13/08/2036",
    dailyTripDate3: "13/10/2036",
    dailyPriceAdult: 169.99,
    dailyPriceChildren: 69.99,
    weekTrip: true,
    weekTripDate1: "18/02/2036 - 25/02/2036",
    weekTripDate2: "18/08/2036 - 25/08/2036",
    weekTripDate3: "18/10/2036 - 25/10/2036",
    weekPriceAdult: 399.99,
    weekPriceChildren: 169.99,
    monthTrip: true,
    monthTripDate1: "12/03/2036 - 12/04/2036",
    monthTripDate2: "12/06/2036 - 12/07/2036",
    monthTripDate3: "12/09/2036 - 12/10/2036",
    monthPriceAdult: 999.99,
    monthPriceChildren: 499.99,
    choosenTrip: "",
    tripPriceAdult: "",
    tripPriceChildren: "",
    dateOption: "",
    choosenDate: "",
    link: "/america/miami",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer hendrerit mattis rhoncus. In eu nunc malesuada, consequat sem a, semper diam. Vestibulum mollis sagittis diam. Aliquam hendrerit tellus sit amet ante rhoncus, blandit mollis lectus sagittis. Aliquam dignissim blandit nisi id laoreet. Phasellus tempus elementum lacinia. Quisque ullamcorper ultricies tortor sit amet scelerisque. Etiam eu magna elementum, euismod tortor nec, efficitur turpis. Mauris consectetur magna suscipit, mattis leo et, bibendum lorem. Integer pretium eu enim nec hendrerit.",
    description2:
      "Nulla sit amet ultrices nunc. Proin sed accumsan risus. Ut tristique lorem ut nunc tempus fermentum. Fusce eu ex sed ligula placerat dapibus. Mauris quis felis porttitor dolor rutrum vehicula ac eu est. Aenean placerat erat vel elementum condimentum. Aliquam pulvinar nisl tellus. Donec ac scelerisque mauris.",
    description3:
      "Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; Duis volutpat tincidunt nisi, ut porttitor orci ultricies vel. Sed venenatis suscipit vulputate. Pellentesque lacus leo, bibendum eu nisi varius, varius porttitor erat. Praesent scelerisque tempor efficitur. Proin ut condimentum nisi, ac facilisis dolor. Phasellus at felis tempus, volutpat lacus a, aliquet risus. Curabitur eu feugiat lectus. Aliquam cursus dolor mollis nisi commodo, id malesuada mi condimentum. Vivamus id metus vitae ante consequat venenatis.",
    inCart: false,
    standardPickUp: 0,
    pickUp: 29,
    choosenPickUp: 0,
    hotelStandard: 0,
    hotelOption1: 69,
    hotelOption2: 99,
    hotelOption3: 139,
    choosenHotel: 0,
    tripStandard: 0,
    tripOption1: 45,
    tripDescription1:
      "In feugiat risus id risus vulputate, eu pellentesque ipsum laoreet. Integer augue massa, condimentum laoreet vulputate vel, laoreet et elit. Ut rutrum ex velit.",
    tripOption2: 99,
    tripDescription2:
      "Vestibulum lacus elit, molestie sed neque ut, eleifend maximus mi. Suspendisse eget massa ac neque pulvinar varius eget vitae lectus.",
    // tripOption3: 149,
    // tripDescription3: 'Fusce sollicitudin vehicula pharetra. Etiam tincidunt quis magna id laoreet. Morbi ut placerat quam. Phasellus vel fermentum sapien.',
    choosenTripOption: 0,
    totalWithOptions: 0
  },
  {
    id: 23,
    continent: 'america',
    img: require( '../Images/America/washington-jorge-alcala.jpg' ),
    title: 'Washington',
    quote: "Washington is a city of Southern efficiency and Northern charm.",
    autor: "John F. Kennedy",
    adultCount: 0,
    childrenCount: 0,
    totalTravelers: 0,
    total: 0,
    dailyTrip: true,
    dailyTripDate1: "12/04/2036",
    dailyTripDate2: "12/05/2036",
    dailyTripDate3: "12/06/2036",
    dailyPriceAdult: 169.99,
    dailyPriceChildren: 69.99,
    weekTrip: false,
    weekTripDate1: "13/04/2036 - 20/04/2036",
    weekTripDate2: "13/05/2036 - 20/05/2036",
    weekTripDate3: "13/06/2036 - 20/06/2036",
    weekPriceAdult: 399.99,
    weekPriceChildren: 169.99,
    monthTrip: false,
    monthTripDate1: "30/03/2036 - 30/04/2036",
    monthTripDate2: "30/06/2036 - 30/07/2036",
    monthTripDate3: "30/09/2036 - 30/10/2036",
    monthPriceAdult: 1099.99,
    monthPriceChildren: 799.99,
    choosenTrip: "",
    tripPriceAdult: "",
    tripPriceChildren: "",
    dateOption: "",
    choosenDate: "",
    link: "/america/washington",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer hendrerit mattis rhoncus. In eu nunc malesuada, consequat sem a, semper diam. Vestibulum mollis sagittis diam. Aliquam hendrerit tellus sit amet ante rhoncus, blandit mollis lectus sagittis. Aliquam dignissim blandit nisi id laoreet. Phasellus tempus elementum lacinia. Quisque ullamcorper ultricies tortor sit amet scelerisque. Etiam eu magna elementum, euismod tortor nec, efficitur turpis. Mauris consectetur magna suscipit, mattis leo et, bibendum lorem. Integer pretium eu enim nec hendrerit.",
    description2:
      "Nulla sit amet ultrices nunc. Proin sed accumsan risus. Ut tristique lorem ut nunc tempus fermentum. Fusce eu ex sed ligula placerat dapibus. Mauris quis felis porttitor dolor rutrum vehicula ac eu est. Aenean placerat erat vel elementum condimentum. Aliquam pulvinar nisl tellus. Donec ac scelerisque mauris.",
    description3:
      "Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; Duis volutpat tincidunt nisi, ut porttitor orci ultricies vel. Sed venenatis suscipit vulputate. Pellentesque lacus leo, bibendum eu nisi varius, varius porttitor erat. Praesent scelerisque tempor efficitur. Proin ut condimentum nisi, ac facilisis dolor. Phasellus at felis tempus, volutpat lacus a, aliquet risus. Curabitur eu feugiat lectus. Aliquam cursus dolor mollis nisi commodo, id malesuada mi condimentum. Vivamus id metus vitae ante consequat venenatis.",
    inCart: false,
    standardPickUp: 0,
    pickUp: 129,
    choosenPickUp: 0,
    hotelStandard: 'Unavaiable',
    hotelOption1: 39,
    hotelOption2: 89,
    choosenHotel: 0,
    tripStandard: 0,
    tripOption1: 79,
    tripDescription1: 'Donec sit amet dui tempus tellus congue scelerisque et id est. In consequat finibus consectetur.',
    tripOption2: 129,
    tripDescription2: 'Quisque consectetur urna ut enim rhoncus, fringilla viverra augue dapibus. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae',
    tripOption3: 149,
    tripDescription3: 'Fusce sollicitudin vehicula pharetra. Etiam tincidunt quis magna id laoreet. Morbi ut placerat quam. Phasellus vel fermentum sapien.',
    choosenTripOption: 0,
    totalWithOptions: 0
  },
  {
    id: 24,
    continent: 'america',
    img: require( '../Images/America/buenos-sander-crombach.jpg' ),
    title: 'Buenos Aires',
    quote: 'Buenos Aires is easily one of the most stylish cities in the world with its eclectic collection of neighborhoods, each with its own unique charm.',
    autor:  'Ben Elliot',
    adultCount: 0,
    childrenCount: 0,
    totalTravelers: 0,
    total: 0,
    dailyTrip: true,
    dailyTripDate1: "10/02/2036",
    dailyTripDate2: "10/08/2036",
    dailyTripDate3: "10/10/2036",
    dailyPriceAdult: 99.99,
    dailyPriceChildren: 49.99,
    weekTrip: true,
    weekTripDate1: "13/04/2036 - 20/04/2036",
    weekTripDate2: "13/05/2036 - 20/05/2036",
    weekTripDate3: "13/06/2036 - 20/06/2036",
    weekPriceAdult: 399.99,
    weekPriceChildren: 169.99,
    monthTrip: true,
    monthTripDate1: "12/03/2036 - 12/04/2036",
    monthTripDate2: "12/06/2036 - 12/07/2036",
    monthTripDate3: "12/09/2036 - 12/10/2036",
    monthPriceAdult: 999.99,
    monthPriceChildren: 499.99,
    choosenTrip: "",
    tripPriceAdult: "",
    tripPriceChildren: "",
    dateOption: "",
    choosenDate: "",
    link: "/america/buenos-aires",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer hendrerit mattis rhoncus. In eu nunc malesuada, consequat sem a, semper diam. Vestibulum mollis sagittis diam. Aliquam hendrerit tellus sit amet ante rhoncus, blandit mollis lectus sagittis. Aliquam dignissim blandit nisi id laoreet. Phasellus tempus elementum lacinia. Quisque ullamcorper ultricies tortor sit amet scelerisque. Etiam eu magna elementum, euismod tortor nec, efficitur turpis. Mauris consectetur magna suscipit, mattis leo et, bibendum lorem. Integer pretium eu enim nec hendrerit.",
    description2:
      "Nulla sit amet ultrices nunc. Proin sed accumsan risus. Ut tristique lorem ut nunc tempus fermentum. Fusce eu ex sed ligula placerat dapibus. Mauris quis felis porttitor dolor rutrum vehicula ac eu est. Aenean placerat erat vel elementum condimentum. Aliquam pulvinar nisl tellus. Donec ac scelerisque mauris.",
    description3:
      "Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; Duis volutpat tincidunt nisi, ut porttitor orci ultricies vel. Sed venenatis suscipit vulputate. Pellentesque lacus leo, bibendum eu nisi varius, varius porttitor erat. Praesent scelerisque tempor efficitur. Proin ut condimentum nisi, ac facilisis dolor. Phasellus at felis tempus, volutpat lacus a, aliquet risus. Curabitur eu feugiat lectus. Aliquam cursus dolor mollis nisi commodo, id malesuada mi condimentum. Vivamus id metus vitae ante consequat venenatis.",
    inCart: false,
    standardPickUp: 0,
    pickUp: 129,
    choosenPickUp: 0,
    hotelStandard: 0,
    hotelOption1: 39,
    choosenHotel: 0,
    tripStandard: 0,
    tripOption1: 39,
    tripDescription1:
      "Donec sit amet dui tempus tellus congue scelerisque et id est. In consequat finibus consectetur.",
    tripOption2: 69,
    tripDescription2:
      "Quisque consectetur urna ut enim rhoncus, fringilla viverra augue dapibus. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae",
    tripOption3: 99,
    tripDescription3:
      "Fusce sollicitudin vehicula pharetra. Etiam tincidunt quis magna id laoreet. Morbi ut placerat quam. Phasellus vel fermentum sapien.",
    choosenTripOption: 0,
    totalWithOptions: 0
  },
  {
    id: 25,
    continent: 'america',
    img: require( '../Images/America/rio-raphael-nogueira.jpg' ),
    title: 'Rio De Janeiro',
    quote: 'Golden beaches and lush mountains, samba-fueled nightlife and spectacular football matches: welcome to the Cidade Maravilhosa (Marvelous City).',
    autor:  null,
    adultCount: 0,
    childrenCount: 0,
    totalTravelers: 0,
    total: 0,
    dailyTrip: false,
    dailyTripDate1: "12/04/2036",
    dailyTripDate2: "12/05/2036",
    dailyTripDate3: "12/06/2036",
    dailyPriceAdult: 169.99,
    dailyPriceChildren: 69.99,
    weekTrip: true,
    weekTripDate1: "05/02/2036 - 12/02/2036",
    weekTripDate2: "05/08/2036 - 12/08/2036",
    weekTripDate3: "05/10/2036 - 12/10/2036",
    weekPriceAdult: 499.99,
    weekPriceChildren: 299.99,
    monthTrip: true,
    monthTripDate1: "12/03/2036 - 12/04/2036",
    monthTripDate2: "12/06/2036 - 12/07/2036",
    monthTripDate3: "12/09/2036 - 12/10/2036",
    monthPriceAdult: 999.99,
    monthPriceChildren: 499.99,
    choosenTrip: "",
    tripPriceAdult: "",
    tripPriceChildren: "",
    dateOption: "",
    choosenDate: "",
    link: "/america/rio-de-janeiro",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer hendrerit mattis rhoncus. In eu nunc malesuada, consequat sem a, semper diam. Vestibulum mollis sagittis diam. Aliquam hendrerit tellus sit amet ante rhoncus, blandit mollis lectus sagittis. Aliquam dignissim blandit nisi id laoreet. Phasellus tempus elementum lacinia. Quisque ullamcorper ultricies tortor sit amet scelerisque. Etiam eu magna elementum, euismod tortor nec, efficitur turpis. Mauris consectetur magna suscipit, mattis leo et, bibendum lorem. Integer pretium eu enim nec hendrerit.",
    description2:
      "Nulla sit amet ultrices nunc. Proin sed accumsan risus. Ut tristique lorem ut nunc tempus fermentum. Fusce eu ex sed ligula placerat dapibus. Mauris quis felis porttitor dolor rutrum vehicula ac eu est. Aenean placerat erat vel elementum condimentum. Aliquam pulvinar nisl tellus. Donec ac scelerisque mauris.",
    description3:
      "Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; Duis volutpat tincidunt nisi, ut porttitor orci ultricies vel. Sed venenatis suscipit vulputate. Pellentesque lacus leo, bibendum eu nisi varius, varius porttitor erat. Praesent scelerisque tempor efficitur. Proin ut condimentum nisi, ac facilisis dolor. Phasellus at felis tempus, volutpat lacus a, aliquet risus. Curabitur eu feugiat lectus. Aliquam cursus dolor mollis nisi commodo, id malesuada mi condimentum. Vivamus id metus vitae ante consequat venenatis.",
    inCart: false,
    standardPickUp: 0,
    pickUp: 39,
    choosenPickUp: 0,
    hotelStandard: 0,
    hotelOption1: 59,
    choosenHotel: 0,
    tripStandard: 'Unavaiable',
    tripOption1: 49,
    tripDescription1: 'Donec sit amet dui tempus tellus congue scelerisque et id est. In consequat finibus consectetur.',
    tripOption2: 89,
    tripDescription2: 'Quisque consectetur urna ut enim rhoncus, fringilla viverra augue dapibus. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae',
    tripOption3: 129,
    tripDescription3: 'Fusce sollicitudin vehicula pharetra. Etiam tincidunt quis magna id laoreet. Morbi ut placerat quam. Phasellus vel fermentum sapien.',
    choosenTripOption: 0,
    totalWithOptions: 0
  },
  {
    id: 26,
    continent: 'america',
    img: require( '../Images/America/mechico-manuel-arroyo.jpg' ),
    title: 'Mexico city',
    quote: 'Rising from the ruins of the Aztec capital, Tenochtitlan, Mexico City offers a unique collision of contemporary city life and historic preservation. World-class museums, restaurants and parks rub shoulders with the remains of several cultures. The nightlife, the shopping and the history make it a must-see regardless of your travel style.',
    autor:  null,
    adultCount: 0,
    childrenCount: 0,
    totalTravelers: 0,
    total: 0,
    dailyTrip: true,
    dailyTripDate1: "12/04/2036",
    dailyTripDate2: "12/05/2036",
    dailyTripDate3: "12/06/2036",
    dailyPriceAdult: 169.99,
    dailyPriceChildren: 69.99,
    weekTrip: true,
    weekTripDate1: "13/04/2036 - 20/04/2036",
    weekTripDate2: "13/05/2036 - 20/05/2036",
    weekTripDate3: "13/06/2036 - 20/06/2036",
    weekPriceAdult: 399.99,
    weekPriceChildren: 169.99,
    monthTrip: false,
    monthTripDate1: "30/03/2036 - 30/04/2036",
    monthTripDate2: "30/06/2036 - 30/07/2036",
    monthTripDate3: "30/09/2036 - 30/10/2036",
    monthPriceAdult: 1099.99,
    monthPriceChildren: 799.99,
    choosenTrip: "",
    tripPriceAdult: "",
    tripPriceChildren: "",
    dateOption: "",
    choosenDate: "",
    link: "/america/mexico",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer hendrerit mattis rhoncus. In eu nunc malesuada, consequat sem a, semper diam. Vestibulum mollis sagittis diam. Aliquam hendrerit tellus sit amet ante rhoncus, blandit mollis lectus sagittis. Aliquam dignissim blandit nisi id laoreet. Phasellus tempus elementum lacinia. Quisque ullamcorper ultricies tortor sit amet scelerisque. Etiam eu magna elementum, euismod tortor nec, efficitur turpis. Mauris consectetur magna suscipit, mattis leo et, bibendum lorem. Integer pretium eu enim nec hendrerit.",
    description2:
      "Nulla sit amet ultrices nunc. Proin sed accumsan risus. Ut tristique lorem ut nunc tempus fermentum. Fusce eu ex sed ligula placerat dapibus. Mauris quis felis porttitor dolor rutrum vehicula ac eu est. Aenean placerat erat vel elementum condimentum. Aliquam pulvinar nisl tellus. Donec ac scelerisque mauris.",
    description3:
      "Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; Duis volutpat tincidunt nisi, ut porttitor orci ultricies vel. Sed venenatis suscipit vulputate. Pellentesque lacus leo, bibendum eu nisi varius, varius porttitor erat. Praesent scelerisque tempor efficitur. Proin ut condimentum nisi, ac facilisis dolor. Phasellus at felis tempus, volutpat lacus a, aliquet risus. Curabitur eu feugiat lectus. Aliquam cursus dolor mollis nisi commodo, id malesuada mi condimentum. Vivamus id metus vitae ante consequat venenatis.",
    inCart: false,
    standardPickUp: 0,
    pickUp: 109,
    choosenPickUp: 0,
    hotelStandard: 0,
    hotelOption1: 39,
    hotelOption2: 89,
    choosenHotel: 0,
    tripStandard: "Unavaiable",
    tripOption1: 29,
    tripDescription1:
      "Donec sit amet dui tempus tellus congue scelerisque et id est. In consequat finibus consectetur.",
    tripOption2: 49,
    tripDescription2:
      "Quisque consectetur urna ut enim rhoncus, fringilla viverra augue dapibus. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae",
    tripOption3: 89,
    tripDescription3:
      "Fusce sollicitudin vehicula pharetra. Etiam tincidunt quis magna id laoreet. Morbi ut placerat quam. Phasellus vel fermentum sapien.",
    choosenTripOption: 0,
    totalWithOptions: 0
  }
]

export default America